import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";
import DataHandler from "../../handlers/DataHandler";

export const createService = {
    createCategory: createCategory,
    getQuestionTypes: getQuestionTypes,
    getQuestionCategories: getQuestionCategories,
    getAllQuestionCategories: getAllQuestionCategories,
    getQuestionDifficulty: getQuestionDifficulty,
    getQuestionLanguage: getQuestionLanguage,
    getQuestionSource: getQuestionSource,
    getQuestionSubject: getQuestionSubject,
    getQuestionAuthor: getQuestionAuthor,
    getQuestionYear: getQuestionYear,
    getQuestionTerm: getQuestionTerm,
    getQuestionGrade: getQuestionGrade,
    getQuestionChapter: getQuestionChapter,
    getQuestionById:getQuestionById,
    getAllQuestionMetaData:getAllQuestionMetaData,
    getAllQuestionMetaDataWithCount:getAllQuestionMetaDataWithCount
};


async function getQuestionTypes() {

    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/question/types/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionDifficulty(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/difficulties/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionById(id){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/questions/getById/${id}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionGrade(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/grades/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionChapter(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/chapters/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionLanguage(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/languages/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionSource(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/question/sources/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionSubject(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/subjects/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionAuthor(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/authors/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionYear(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/years/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionTerm(){
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/terms/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getQuestionCategories() {
  const localKey = "questionCategories";

  const cached = localStorage.getItem(localKey);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (err) {
      console.warn("Failed to parse cached categories:", err);
      localStorage.removeItem(localKey); 
    }
  }

  const requestOptions = {
    method: 'GET',
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const data = await fetch(`${config.oat_api_url}/question/categories/getAll/`, requestOptions)
    .then(APIHandler.handleResponse);

  localStorage.setItem(localKey, JSON.stringify(data));

  return data;
}

async function getAllQuestionCategories(limit, offset, sort_column, sort_direction, search_term) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
 
    return await fetch(`${config.oat_api_url}/question/categories/getAllCategories/?limit=${limit}&offset=${offset}&sort_column=${sort_column}&sort_direction=${sort_direction}&search_term=${search_term}`, requestOptions).then(APIHandler.handleResponse);
}

async function createCategory(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    return await fetch(`${config.oat_api_url}/question/categories/add/`, requestOptions).then(APIHandler.handleResponse);
}

const CACHE_KEY = 'question_metadata_response';
const META_LOADED_KEY = 'meta-data-load';

let apiPromise = null; 

// export async function getAllQuestionMetaData() {
//   try {
//     const isLoaded = sessionStorage.getItem(META_LOADED_KEY);
//     const cachedData = sessionStorage.getItem(CACHE_KEY);

   
//     if (isLoaded === 'true') {
//       if (!apiPromise) {
//         apiPromise = (async () => {
//           const requestOptions = {
//             method: 'GET',
//             headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
//           };

//           const response = await fetch(
//             `${config.oat_api_url}/questions/get-all-meta-data/`,
//             requestOptions
//           );

//           const result = await APIHandler.handleResponse(response);

//           if (result.success) {
//             sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
//             sessionStorage.removeItem(META_LOADED_KEY); // remove after refresh
//           }

//           return result;
//         })();

//         apiPromise.finally(() => {
//           apiPromise = null;
//         });
//       }

//       return apiPromise;
//     }


//     if (cachedData) {
//       return JSON.parse(cachedData);
//     }

  
//     if (!apiPromise) {
//       apiPromise = (async () => {
//         const requestOptions = {
//           method: 'GET',
//           headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
//         };

//         const response = await fetch(
//           `${config.oat_api_url}/questions/get-all-meta-data/`,
//           requestOptions
//         );

//         const result = await APIHandler.handleResponse(response);

//         if (result.success) {
//           sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
//           sessionStorage.setItem(META_LOADED_KEY, 'true'); 
//         }

//         return result;
//       })();


//       apiPromise.finally(() => {
//         apiPromise = null;
//       });
//     }

//     return apiPromise;

//   } catch (error) {
//     console.error("Question metadata fetch error:", error);
//     apiPromise = null;
//     throw error;
//   }
// }

export async function getAllQuestionMetaData() {
  try {
    const requestOptions = {
      method: 'GET',
      headers: APIHandler.getHeader(
        config.azure_ad_config.apis.OAT.name
      ),
    };

    const response = await fetch(
      `${config.oat_api_url}/questions/get-all-meta-data/`,
      requestOptions
    );

    const result = await APIHandler.handleResponse(response);

    return result;

  } catch (error) {
    console.error("Question metadata fetch error:", error);
    throw error;
  }
}

async function getAllQuestionMetaDataWithCount(user_id) {
    var user_id = DataHandler.getFromSession("user_id")
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/questions/get-all-meta-data-with-count/${user_id}`, requestOptions);
    return APIHandler.handleResponse(response);
}